import { FaPhone ,FaMailBulk} from "react-icons/fa";

export default function ContactUs() {
    return (
        <div className='ContactUs'>
            <p>Come Visit us at our office.
                <br />
                <a href="https://www.google.com/maps/place/35+E+100+N+St,+Centerfield,+UT+84622/@39.1249012,-111.8209894,17z/data=!3m1!4b1!4m6!3m5!1s0x874b81a3066f1fc3:0x4f264e56a2f6efe2!8m2!3d39.1248971!4d-111.8184145!16s%2Fg%2F11c87k1jh1?entry=ttu&g_ep=EgoyMDI0MTAwMi4xIKXMDSoASAFQAw%3D%3D">
                35 East 100 North,<br />
                Centerfield Utah 84622
                </a>
                <br />
                Or
                <br />
                Call us at : <a href="tel:4352627460">(435) 262-7460 <FaPhone></FaPhone>
                </a>
                <br />
                Email at: <a href="mailto:knudsen.insurance@gmail.com">knudsen.insurance@gmail.com <FaMailBulk></FaMailBulk>
                </a>
                <br/>
                Mail to: P.O. Box 247 Gunnison Utah 84634
            </p>
        </div>

    );
}